<template>
  <section class="n-view-register h-screen p-10 flex justify-center items-center">
    <NCard class="w-full max-w-[450px] shadow-md">
      <div>
        <img class="mx-auto p-8" src="/images/logo-dark.png" alt="" />
        <NForm ref="form" :model="model" :rules="rules" class="!grid-cols-1">

          <NSelect v-model:value="model.providerType" :allOption="false" :showSearch="false" :options="ptOptions" v-bind="providerTypeAttrs"/>

          <NInputPreSuffix v-if="isMail" v-model:value="model.email" v-bind="emailAttrs">
            <template #suffix>
              <mail-outlined />
            </template>
          </NInputPreSuffix>

          <div v-if="isPhone" class="grid grid-cols-12 gap-1.5">
            <div class="col-start-1 col-end-6">
              <NSelect v-model:value="model.countryCode" :allOption="false" :showSearch="false" :options="countryCodeOptions" v-bind="countryCodeTypeAttrs"/>
            </div>
            <div class="col-start-6 col-end-13">
              <NInputPreSuffix v-if="isPhone" v-model:value="model.phone" v-bind="phoneAttrs">
                <template #suffix>
                  <mobile-outlined />
                </template>
              </NInputPreSuffix>
            </div>
          </div>

          <div class="flex space-x-2"></div>

          <NButton class="n-register-button" size="large" block type="primary" :loading="loading" @click="onPost()">
            <span>{{ $tl('recoverPassword') }}</span>
          </NButton>


        </NForm>
        <div class="text-right text-base py-2 pr-2">
          <span class="mr-5">
            <RouterLink to="/login">{{ $tl('backTo') }}</RouterLink>
          </span>
        </div>
      </div>
      <div class="mt-10 mb-3 text-center text-base text-gray-600 grid items-center gap-3 grid-flow-col place-content-center">
        {{ COPYRIGHT }}
        <NChannelSwitch />
        <NLanguageSwitcher />
        <NHelper />
      </div>
    </NCard>
  </section>
</template>

<script setup>
import {useLanguage, useModelPost, useRouter, useValidate} from '@front/hooks';
import {register, resetPasswordRequest} from '@front/api/utility';
import {computed, reactive} from 'vue';
import {COPYRIGHT, VALIDATION_RULE, USERNAME_PROVIDER_TYPE} from '@front/constant';
import {getMobiles} from "@/services";
import {generateMobiles} from "@front/utils";

const ptOptions = computed(() =>[{ label: tl('emailPassword'), value: 'MAIL_PASSWORD' }, { label: tl('phonePassword'), value: 'PHONE_PASSWORD'}]);
const sourceMobileOptions = getMobiles();
const countryCodeOptions = computed(() => { return generateMobiles(sourceMobileOptions);});

const isMail = computed(() => model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD);
const isPhone = computed(() => model.providerType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD);
const model = reactive({ username: '', password: '' , providerType: USERNAME_PROVIDER_TYPE.PHONE_PASSWORD, countryCode: '+55' , email: undefined, phone: undefined});

const { tl, t, PREFIX } = useLanguage();
const { router, routerTo } = useRouter();
const message = computed(() => {
  return t('resetPassword', PREFIX.WARNING, { email: model.email });
});
const validation = computed(() => ({
  email: { required: model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD, isEmail: true, maxLength: VALIDATION_RULE.Customer.username.maxLength },
  phone: { required: model.providerType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD, isMobile: true, maxLength: VALIDATION_RULE.Customer.mobile.maxLength },
  countryCode: { required: model.providerType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD, maxlength: 5},
  providerType : { required: true }
}));

const { form, loading, onPost } = useModelPost({
  post: forgotPwd,
  // successPath: '/forgotNotice',
});

const { rules } = useValidate({ formRef: form, validation });

// const disabled = computed(() => !!form.value?.errorMap?.email || !model.email);
const disabled = computed(() => {
  if(model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD){
    return !!form.value?.errorMap?.email || !model.email;
  }

  if(model.providerType === USERNAME_PROVIDER_TYPE.PHONE_PASSWORD){
    return  (!!form.value?.errorMap?.phone || !model.phone ) || (!!form.value?.errorMap?.countryCode || !model.countryCode );
  }

  return true;
});

const emailAttrs = computed(() => ({
  size: 'large',
  name: 'email',
  placeholder: tl('recoverMailPassword'),
  disabled: loading.value,
}));

const providerTypeAttrs = computed(() => ({
  size: 'large',
  name: 'providerType',
  placeholder: tl('providerType'),
  disabled: loading.value,
}));

const countryCodeTypeAttrs = computed(() => ({
  size: 'large',
  name: 'countryCode',
  placeholder: tl('countryCode'),
  disabled: loading.value,
}));

const phoneAttrs = computed(() => ({
  size: 'large',
  name: 'phone',
  placeholder: tl('recoverPhonePassword'),
  disabled: loading.value,
}));

async function forgotPwd() {
  const params = {
    username: model.providerType === USERNAME_PROVIDER_TYPE.MAIL_PASSWORD ? model.email : (model.countryCode + model.phone),
    type: model.providerType,
  };

  const r = await resetPasswordRequest(params);



  if(r.success){
    routerTo('/passwordReset/' + encodeURIComponent(params.username) + '/' + encodeURIComponent(model.providerType));
  }
}

// async function forgotPwd() {
//   const params = {
//     username: model.email,
//   };
//
//   await resetPasswordRequest(params);
// }

</script>

<style lang="less">
.n-view-register {
  background-image: url('/images/shape01.png');
  background-position: center;

  .n-language-switcher {
    gap: 6px;
  }
}
</style>
